/**
 * Hex colors for Elements {@link NewSeat} zone index 1–5.
 * Kept in sync with listado por zona / pasajeros / mapa.
 */
const ELEMENTS_ZONE_COLORS = {
  1: '#B89C0D',
  2: '#69AF72',
  3: '#795AF9',
  4: '#2B86FC',
  5: '#E69A30',
} as const;

export { ELEMENTS_ZONE_COLORS };

/** @deprecated Migrate to the named import before removing this compatibility alias. */
// oxlint-disable-next-line no-default-export -- Compatibility with the conflicting default import in PR #2962
export default ELEMENTS_ZONE_COLORS;
